export enum KioskType {
  PARTTEAM = 'PARTTEAM',
  SHAREBOX = 'SHAREBOX',
}

// Those are kept for compatibility, but there is no difference between those models.
export enum PartteamModel {
  INDOOR = 'INDOOR',
  OUTDOOR = 'OUTDOOR',
}

export enum ShareboxModel {
  I32 = 'I32',
  S32 = 'S32',
  W64 = 'W64',
  M28 = 'M28',
  S32_PLUS = 'S32_PLUS',
}

export type KioskModel = PartteamModel | ShareboxModel;

/** @description This list should be used as little as possible, it's intended for styling purposes **only**. */
export const SHAREBOX_INDOOR_KIOSK_MODELS = [ShareboxModel.I32, ShareboxModel.W64, ShareboxModel.S32_PLUS];
